import * as React from "react";
import { cn } from "@racoon/ui";

/** incident: a reason was given; debt: «Не успели (долг)»; none: no reason yet. */
export type IncidentChipTone = "incident" | "debt" | "none";

const TONE_CLASS: Record<IncidentChipTone, string> = {
  incident: "bg-surface-warning-light text-text-warning",
  debt: "bg-surface-error-light text-text-error",
  none: "bg-slate-100 text-text-subtle",
};

/**
 * A job's incident as the order map shows it: a tinted chip outlined in its own text colour
 * (Figma), its explanation on hover.
 */
export const IncidentChip: React.FC<{
  tone: IncidentChipTone;
  title?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ tone, title, className, children }) => (
  <span
    className={cn(
      "rounded-md border border-current px-2 py-0.5 text-xs",
      TONE_CLASS[tone],
      className,
    )}
    title={title}
  >
    {children}
  </span>
);
